'use strict';

var $ = require('jquery');

module.exports = {
	appendTrackingToAmazonLinks: function() {
		var queryStringParams = new URLSearchParams(window.location.search);
		var refId = queryStringParams.get('refid');

		if (!refId) {
			return;
		}

		var refUrl = window.location.origin + window.location.pathname;
		var $amazonLinks = $('a[href^="https://www.amazon."]'); // Match all potential TLDs

		$amazonLinks.each(function(index, link) {
			var linkQueryStringParams = new URLSearchParams(link.search);
			var tag = linkQueryStringParams.get('tag');

			if (!tag) {
				return;
			}

			linkQueryStringParams.set('asc_source', 'paidtraffic');
			linkQueryStringParams.set('asc_campaign', refId);
			linkQueryStringParams.set('asc_refurl', refUrl);
			link.search = linkQueryStringParams;
		});
	}
};
